import template from './suggestion-form.html.twig';
import './suggestion-form.scss';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-suggestion-form', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        formTitle() {
            return this.$tc(this.entity.isNew()
                ? 'TopdataEnhancedSearchSW6.topdata-es-suggestion.formTitleAdd'
                : 'TopdataEnhancedSearchSW6.topdata-es-suggestion.formTitleEdit');
        },

        targetTypeOptions() {
            return [
                { label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.type.category'), value: 'category' },
                { label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.type.product'), value: 'product' },
                { label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.type.search'), value: 'search' },
                { label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.type.custom'), value: 'custom' },
            ];
        },

        languageOptions() {
            return [{
                value: null,
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.languageGlobal'),
            }, {
                value: 'de',
                label: 'Deutsch',
            }, {
                value: 'en',
                label: 'English',
            }, {
                value: 'fr',
                label: 'Français',
            }];
        },

        // Single source of truth stays targetUrl (/navigation/{id}, /detail/{id}); this
        // computed maps between the chooser and that URL.
        targetEntityId: {
            get() {
                const url = this.entity.targetUrl || '';
                if (this.entity.targetType === 'category') {
                    const m = /^\/navigation\/([0-9a-f]{32})$/i.exec(url);
                    return m ? m[1] : null;
                }
                if (this.entity.targetType === 'product') {
                    const m = /^\/detail\/([0-9a-f]{32})$/i.exec(url);
                    return m ? m[1] : null;
                }
                return null;
            },
            set(id) {
                if (this.entity.targetType === 'category') {
                    this.entity.targetUrl = id ? `/navigation/${id}` : null;
                } else if (this.entity.targetType === 'product') {
                    this.entity.targetUrl = id ? `/detail/${id}` : null;
                }
            },
        },

        targetUrlPreview() {
            const query = (this.entity.targetQuery || '').trim().replace(/^[?&]+/, '');

            if (this.entity.targetType === 'search') {
                const term = encodeURIComponent(this.entity.term || '');
                let preview = `/search?search=${term}`;
                if (query) {
                    preview += (preview.includes('?') ? '&' : '?') + query;
                }
                return preview;
            }

            let url = this.entity.targetUrl || '';
            if (url && query) {
                url += (url.includes('?') ? '&' : '?') + query;
            }
            return url;
        },

        isChooserType() {
            return this.entity.targetType === 'category' || this.entity.targetType === 'product';
        },

        categoryCriteria() {
            const criteria = new Criteria(1, 100);
            criteria.addFilter(Criteria.equals('active', true));
            criteria.addSorting(Criteria.sort('level', 'ASC'));
            return criteria;
        },

        productCriteria() {
            const criteria = new Criteria(1, 100);
            criteria.addFilter(Criteria.equals('active', true));
            return criteria;
        },
    },

    methods: {
        getCategoryName(category) {
            return (category.translated && category.translated.name) || category.name;
        },

        getCategoryBreadcrumb(category) {
            if (category.breadcrumb && Object.keys(category.breadcrumb).length > 0) {
                return Object.values(category.breadcrumb).join(' / ');
            }
            return this.getCategoryName(category);
        },

        // Breadcrumb without the root node (assumed to be identical for all
        // choices), leaf name excluded when there is an identical parent line.
        getCategoryShortBreadcrumb(category) {
            if (!category.breadcrumb) {
                return null;
            }
            const path = Object.values(category.breadcrumb).slice(1);
            return path.length > 1 ? path.join(' > ') : null;
        },

        onTargetTypeChange() {
            this.entity.targetUrl = null;
            this.entity.targetQuery = null;
        },

        async onSave() {
            this.isLoading = true;
            try {
                if (this.isChooserType && !this.targetUrlPreview) {
                    this.createNotificationError({
                        message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.field.targetRequired'),
                    });
                    this.isLoading = false;
                    return;
                }
                await this.repository.save(this.entity, Shopware.Context.api);
                this.$emit('save');
            } catch (e) {
                this.createNotificationError({ message: e.message });
            } finally {
                this.isLoading = false;
            }
        },
    },
});
